
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { LocalizationServices } from '@/services/LocalizationServices';
import store from '@/store';
import * as OM from '@/Model'
import { BookingClient, ContractClient } from '@/services/Services';
import { ModalServices } from '@/services/ModalServices';

@Options({})
export default class startPercorsoModal extends Vue {


    @Prop() userIdentifier: string;
    @Prop() categoryIdentifier: string;
    @Prop() okCallback: (
        additionalData: { [key: string]: string[]; },
        boughtPackageIdentifier: string,
        isForFamigliare: boolean) => void;
    @Prop() remainingFreeBooking: number;
    @Prop({ default: false }) isRestrictedCategory: boolean;

    userAdditionalData: { [key: string]: string[]; } = {} ;
    formBaseFields: OM.BaseFieldWithBookingConfigurationTypeBM[] = [];
    bookingAdditionalData: OM.BookingUserAdditionalDataVM = new OM.BookingUserAdditionalDataVM();
    remainingBooking: OM.RemainingBookingVM = new OM.RemainingBookingVM()

    additionalData: { [key: string]: string[]; } = {} ;
    boughtPackageIdentifier: string = "";

    created(){
        this.userAdditionalData = this.$store.state.user.additionalData

        Promise.all([
            BookingClient.getMyAdditionalData(
                this.categoryIdentifier
            ),
            ContractClient.getBookingForm(this.$store.state.user.companyIdentifier),
            this.getRemainingBooking()
        ]).then(xs => {
            this.bookingAdditionalData = xs[0]
            this.formBaseFields = xs[1]

            const fields = this.filteredBaseFields.map((x) => x.identifier)
            let filteredAdditionalData: { [key: string]: string[] } = {}

            if (this.bookingAdditionalData.lastCategoryUserReservation) {
                Object.keys(this.bookingAdditionalData.lastCategoryUserReservation)
                .filter((x) => fields.includes(x))
                .forEach((el) => {
                    filteredAdditionalData[el] = this.bookingAdditionalData.lastCategoryUserReservation[el]
                })
            } else if (this.bookingAdditionalData.lastUserReservation) {
                Object.keys(this.bookingAdditionalData.lastUserReservation)
                .filter((x) => fields.includes(x))
                .forEach((el) => {
                    filteredAdditionalData[el] = this.bookingAdditionalData.lastUserReservation[el]
                })
            } else if (this.userAdditionalData) {
                Object.keys(this.userAdditionalData)
                .filter((x) => fields.includes(x))
                .forEach((el) => {
                    filteredAdditionalData[el] = this.userAdditionalData[el]
                })
            }

            this.additionalData = filteredAdditionalData
        }).catch(error => {
            ModalServices.alertModal(
                LocalizationServices.GetLocalizedValue("Errore!", "Errore!"),
                error.Message
            )
        })
    }

    getRemainingBooking() {
        ContractClient.getMyRemainingBooking(
            this.categoryIdentifier,
            false,
        ).then((x) => {
            this.remainingBooking = x

            if (this.remainingBooking.remainingFreeBooking! > 0)
                this.boughtPackageIdentifier = ''
            else if (this.remainingBooking.availableBoughtPackages.length > 0)
                this.boughtPackageIdentifier = this.remainingBooking.availableBoughtPackages[0]
        })
    }

    ok(){
        this.okCallback(this.additionalData, this.boughtPackageIdentifier, false);
    }

    ko(){
        this.$emit('close');
    }

    get filteredBaseFields(){
        const role = (store.state.user?.role || '').toLowerCase()
        const isFamilyUser = role.indexOf('family') !== -1
        const typeFiltered = isFamilyUser
            ? OM.BookingConfigurationType.Family
            : OM.BookingConfigurationType.User

        return this.formBaseFields
            .filter((x) => {
            if (
                (x.bookingConfigurationType == typeFiltered ||
                x.bookingConfigurationType == OM.BookingConfigurationType.Both) &&
                (!x.categoryIdentifier || x.categoryIdentifier == this.categoryIdentifier)
            )
                return x
            })
            .map((x) => x.baseField)
    }

    get disabled(){
        const additionalDataRequired = this.filteredBaseFields
            .filter((x) => x.isRequired)
            .map((x) => x.identifier)

        let requiredCompleted = true

        additionalDataRequired.forEach((el) => {
            if (
            !this.additionalData ||
            Object.keys(this.additionalData).indexOf(el) == -1 ||
            this.additionalData[el].length == 0 ||
            !this.additionalData[el][0]
            )
            requiredCompleted = false
        })

        if (!requiredCompleted) return true

        return (!this.boughtPackageIdentifier && this.remainingBooking.remainingFreeBooking == 0);
    }
}
